window.Rails = require("@rails/ujs")

import './nowsignage/csp_nonce';
import './nowsignage/google_analytics';

Rails.start();
